import {useState} from "react";
import {Modal, Upload} from "antd";
import {InboxOutlined} from '@ant-design/icons';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import TalentCandidate from "../../../models/TalentCandidate";
import {useAuth} from "../../../providers/AuthProvider";

const LOOKUP = {
    "favorites": -1,
    "past-hires": -2,
    "bring-your-own-talent": -3,
}
const InviteByGroupModal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formModel, setFormModel] = useState({})
    const {auth} = useAuth();
    const queryClient = useQueryClient();

    //
    // Invite to Talent Pool
    //

    const inviteByGroupMutation = useMutation(
        ['inviteByGroupMutation'],
        formModel => TalentCandidate.inviteByGroup(auth.clientOrg?.()?.id, formModel),
        {
            onSuccess: async (platform_referrals) => {
                // update talent pool quantities after invite
                queryClient.setQueryData(['fetchTalentPools', {clientId: auth.clientOrg?.()?.id}], oldData => {
                    return oldData.map(pool => {
                        if (pool.id === LOOKUP['bring-your-own-talent']) {
                            return {
                                ...pool,
                                talent_users_count: pool.talent_users_count + platform_referrals.length
                            }
                        }
                        return pool;
                    });
                })

                queryClient.invalidateQueries({predicate: ({queryKey}) => queryKey?.[0] === 'fetchTalentPoolDetail'})

                TB.toast("Invitations sent!", { type: 'success' });
            },
            onError: () => {
                TB.showServerErrorToast();
            }
        }
    )


    const props = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: ".txt,.csv",
        onChange(info) {
            const { status } = info.file;
            console.log(info, 'INFO')
            // if (status !== 'uploading') {
            //     console.log(info.file, info.fileList);
            // }
            // if (status === 'done') {
            //     message.success(`${info.file.name} file uploaded successfully.`);
            // } else if (status === 'error') {
            //     message.error(`${info.file.name} file upload failed.`);
            // }
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
        beforeUpload: (file) => {
            setFormModel({ ...formModel, document_path: file });
            return false;
        },
        onRemove: async (file) => {
            setFormModel({ ...formModel, document_path: undefined });
            inviteByGroupMutation.reset();
        },
        showUploadList: {
            showDownloadIcon: true,
            showRemoveIcon: true,
            showPreviewIcon: true,
        }
    };


    const handleUpload = async () => {
        await inviteByGroupMutation.mutateAsync(formModel)
        setIsModalOpen(false)
        setFormModel({})
    }

    const handleClose = () => {
        setIsModalOpen(false);
        inviteByGroupMutation.reset();
        setFormModel({ ...formModel, document_path: undefined });
    }

    return (
        <>
            <button
                type="button"
                className="btn bg-[#304FFD] text-white p-3 whitespace-nowrap"
                onClick={() => setIsModalOpen(true)}
            >
                Invite a Group
            </button>


            <Modal
                destroyOnClose
                open={isModalOpen}
                onCancel={handleClose}
                closable={false}
                maskClosable
                title={null}
                footer={null}
                bodyStyle={{ padding: 0 }}
                className="w-[700px]"
                zIndex={100}
            >

                <div className="bg-white">
                    {/* <div className="h-14 bg-primary flex items-center pl-4">
                        <button
                            type="button"
                            onClick={() => setIsModalOpen(false)}
                            className="h-[22px]"
                        >
                            <div className="close-icon" />
                        </button>
                    </div> */}

                    <div className="px-8 py-6 flex flex-col gap-4">

                        <div className="flex justify-between gap-4">
                            <p className="text-xl font-semibold">Invite a Group</p>

                            <button
                                type="button"
                                onClick={() => setIsModalOpen(false)}
                                className="h-[22px]"
                            >
                                <div className="close-icon" />
                            </button>
                        </div>

                        <a
                            className="text-sm btn-link-primary text-bold underline"
                            href="/static/sample-bulk-invites.csv"
                        >
                            Start by Downloading the CSV template here.
                        </a>

                        <p className="text-sm">
                             Follow the instructions to add names and emails of recipients. Improperly formatted files will fail to upload.
                        </p>


                        <Upload.Dragger {...props}>
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                            <p className="ant-upload-hint px-3">
                                Accepted file types are .csv and .txt
                            </p>
                        </Upload.Dragger>

                        {inviteByGroupMutation.error && (
                            <div className="bg-wripplePrimaryPaleRed p-4">
                                <p className="text-white">{inviteByGroupMutation.error.message}</p>
                            </div>
                        )}

                        <div className="flex flex-row gap-3 justify-end mt-[50px]">
                            <button
                                className="btn btn-outline-dark w[100px]"
                                // disabled={isUpdating}
                                onClick={handleClose}
                            >
                                Cancel
                            </button>

                            <button
                                className="btn btn-primary"
                                disabled={!formModel.document_path || inviteByGroupMutation?.isLoading}
                                onClick={handleUpload}
                            >
                                Upload
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default InviteByGroupModal;